(function () {
  if (window.saleQuickViewInitialized) return;
  window.saleQuickViewInitialized = true;

  let quickViewOverlay = document.querySelector(".quickview-overlay");

  if (!quickViewOverlay) {
    quickViewOverlay = document.createElement("div");
    quickViewOverlay.className = "quickview-overlay";
    quickViewOverlay.innerHTML = `
      <div class="quickview-modal" role="dialog" aria-modal="true" aria-label="Quick view">
        <button type="button" class="quickview-close" aria-label="Close quick view">&times;</button>

        <div class="quickview-layout">
          <div class="quickview-media">
            <div class="quickview-image-wrap">
              <img class="quickview-image" src="" alt="">
            </div>
          </div>

          <div class="quickview-details">
            <h3 class="quickview-title"></h3>

            <div class="quickview-variants"></div>

            <div class="quickview-price">
              <span class="quickview-price-current"></span>
              <span class="quickview-price-compare"></span>
            </div>

            <div class="quickview-qty">
              <div class="quickview-qty__controls">
                <button type="button" class="quickview-qty__btn quickview-qty__minus" aria-label="Decrease quantity">−</button>
                <input id="quickview-qty-input" type="number" value="1" min="1">
                <button type="button" class="quickview-qty__btn quickview-qty__plus" aria-label="Increase quantity">+</button>
              </div>
            </div>

            <button type="button" class="quickview-add-button">Add To Cart</button>

            <div class="quickview-description-block">
              <div class="quickview-description"></div>
            </div>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(quickViewOverlay);
  }

  const modal = quickViewOverlay.querySelector(".quickview-modal");
  const modalImage = modal.querySelector(".quickview-image");
  const modalTitle = modal.querySelector(".quickview-title");
  const modalVariants = modal.querySelector(".quickview-variants");
  const modalPriceCurrent = modal.querySelector(".quickview-price-current");
  const modalPriceCompare = modal.querySelector(".quickview-price-compare");
  const modalQty = modal.querySelector("#quickview-qty-input");
  const modalAddButton = modal.querySelector(".quickview-add-button");
  const modalClose = modal.querySelector(".quickview-close");
  const modalDescription = modal.querySelector(".quickview-description");
  const qtyMinus = modal.querySelector(".quickview-qty__minus");
  const qtyPlus = modal.querySelector(".quickview-qty__plus");

  function openModalFromCard(card) {
    const variantId = card.dataset.variantId;
    const image = card.dataset.variantImage || "";
    const title =
      card.dataset.productTitle ||
      card.querySelector(".sale-card__title")?.textContent.trim() ||
      "";
    const description = card.dataset.productDescription || "";
    const yarnType = card.dataset.yarnType || "";
    const range = card.dataset.range || "";
    const priceCurrent = card.dataset.variantPrice || "";
    const priceCompare = card.dataset.variantCompare || "";
    const stock = parseInt(card.dataset.variantStock || "0", 10);
    const discountPercent = parseInt(card.dataset.discountPercent || "0", 10);
    const options = [...card.querySelectorAll(".sale-pill")].map((pill) =>
      pill.textContent.trim()
    );

    modalImage.src = image;
    modalImage.alt = title;
    modalTitle.textContent = title;

    modalVariants.innerHTML = "";

    const colourPill = options.find((opt) =>
      !opt.toLowerCase().includes("size:")
    );

    const sizePill = options.find((opt) =>
      opt.toLowerCase().includes("size:")
    );

    /* Range */
    if (range) {
      const rangeSpan = document.createElement("span");
      rangeSpan.className = "quickview-pill quickview-pill--range";
      rangeSpan.textContent = range;
      modalVariants.appendChild(rangeSpan);
    }

    /* Colour */
    if (colourPill) {
      const colourSpan = document.createElement("span");
      colourSpan.className = "quickview-pill quickview-pill--neutral";
      colourSpan.textContent = colourPill;
      modalVariants.appendChild(colourSpan);
    }

    /* Size */
    if (sizePill) {
      const sizeSpan = document.createElement("span");
      sizeSpan.className = "quickview-pill quickview-pill--neutral";
      sizeSpan.textContent = sizePill;
      modalVariants.appendChild(sizeSpan);
    }

    /* Yarn */
    if (yarnType) {
      const yarnSpan = document.createElement("span");
      yarnSpan.className = "quickview-pill quickview-pill--neutral";
      yarnSpan.textContent = yarnType;
      modalVariants.appendChild(yarnSpan);
    }

    /* Sale */
    if (discountPercent > 0) {
      const saleSpan = document.createElement("span");
      saleSpan.className = "quickview-pill quickview-pill--sale";
      saleSpan.textContent = `${discountPercent}% OFF`;
      modalVariants.appendChild(saleSpan);
    }

    /* Stock */
    if (stock > 0 && stock < 20) {
      const stockSpan = document.createElement("span");
      stockSpan.className = "quickview-pill quickview-pill--stock";
      stockSpan.textContent = `Only ${stock} Left`;
      modalVariants.appendChild(stockSpan);
    }

    modalPriceCurrent.textContent = priceCurrent;

    if (priceCompare) {
      modalPriceCompare.textContent = priceCompare;
      modalPriceCompare.style.display = "";
    } else {
      modalPriceCompare.textContent = "";
      modalPriceCompare.style.display = "none";
    }

    modalDescription.innerHTML = description;

    modalQty.value = 1;
    modalAddButton.dataset.variantId = variantId;

    quickViewOverlay.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    quickViewOverlay.classList.remove("active");
    document.body.style.overflow = "";
  }

  function isInteractiveElement(target) {
    return Boolean(
      target.closest(
        'a, button, input, select, textarea, label, summary, [role="button"]'
      )
    );
  }

  document.addEventListener("click", function (e) {
    const card = e.target.closest(".js-sale-quickview");
    if (!card) return;

    if (isInteractiveElement(e.target)) {
      return;
    }

    e.preventDefault();
    openModalFromCard(card);
  });

  modalClose.addEventListener("click", closeModal);

  quickViewOverlay.addEventListener("click", function (e) {
    if (e.target === quickViewOverlay) {
      closeModal();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && quickViewOverlay.classList.contains("active")) {
      closeModal();
    }
  });

  qtyMinus.addEventListener("click", function () {
    const currentValue = parseInt(modalQty.value, 10) || 1;
    modalQty.value = Math.max(1, currentValue - 1);
  });

  qtyPlus.addEventListener("click", function () {
    const currentValue = parseInt(modalQty.value, 10) || 1;
    modalQty.value = currentValue + 1;
  });

  function openPrestigeCartDrawer() {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true })
    );

    const possibleTriggers = [
      '[aria-controls="cart-drawer"]',
      '[href="#cart-drawer"]',
      '[data-action="open-cart"]',
      '.header__icon--cart',
      '.header__cart-toggle'
    ];

    for (const selector of possibleTriggers) {
      const trigger = document.querySelector(selector);
      if (trigger) {
        trigger.click();
        return;
      }
    }
  }

  modalAddButton.addEventListener("click", function () {
    const variantId = this.dataset.variantId;
    const quantity = parseInt(modalQty.value, 10) || 1;

    if (!variantId) return;

    this.disabled = true;
    this.textContent = "Adding...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to add to cart");
        return res.json();
      })
      .then(() => {
        openPrestigeCartDrawer();
        closeModal();
      })
      .catch((err) => {
        console.error("Add to cart failed:", err);
      })
      .finally(() => {
        this.disabled = false;
        this.textContent = "Add To Cart";
      });
  });
})();